import { useSyncExternalStore } from "react";

import { LiveCache, refreshTogether } from "./liveCache.mjs";

/**
 * AJ 2026-09-30: the refreshable read cache (liveCache.mjs, plain .mjs so
 * node:test drives it) and the hook a data hook reads it through.
 */
export { LiveCache, refreshTogether };

/** Re-render when `cache` swaps in refreshed answers; use it as an effect dep. */
export function useLiveCacheVersion(cache: LiveCache<any>): number {
  return useSyncExternalStore(cache.subscribe, cache.getVersion, cache.getVersion);
}
